module.exports = __webpack_public_path__ + "static/media/icon_windows.8c019a7d.svg";